// Week arithmetic primitives.
//
// Every schedule calculation in this feature works in "cycle minutes": a single
// integer counting minutes from Monday 00:00 of week 0 of the rotation. These are
// the four things needed to get in and out of that representation, and before
// this module each of them existed in up to seven separate copies.
//
// Days are Monday-anchored so that a weekend range like "Fri → Sun" reads as one
// forward span inside a week rather than a wrap into the next one.

export const DAYS_OF_WEEK = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

export const DAY_INDEX = DAYS_OF_WEEK.reduce((acc, day, i) => {
  acc[day] = i
  return acc
}, {})

export const MIN_PER_HOUR = 60
export const MIN_PER_DAY = 24 * MIN_PER_HOUR // 1440
export const MIN_PER_WEEK = 7 * MIN_PER_DAY // 10080

/**
 * 'HH:MM' → minutes since midnight. Accepts a single-digit hour ('9:00') and a
 * missing minute part ('9'). Out-of-range values are clamped rather than allowed
 * to push a block into the following day; an unparseable value is midnight.
 */
export function timeToMin(hhmm) {
  const m = /^(\d{1,2}):?(\d{0,2})/.exec(String(hhmm || '00:00').trim())
  if (!m) return 0
  const h = Math.max(0, Math.min(23, Number(m[1]) || 0))
  const mm = Math.max(0, Math.min(59, Number(m[2]) || 0))
  return h * 60 + mm
}

/** Minutes since midnight → 'HH:MM'. Wraps, so 1500 and -1380 both give '01:00'. */
export function minToHHMM(mins) {
  const m = ((mins % MIN_PER_DAY) + MIN_PER_DAY) % MIN_PER_DAY
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`
}
